export default "__VITE_ASSET__c3e80fbb__"